import Flickity from 'flickity';

import debounce from '../util/debounce';
import {register} from '../vendor/theme-scripts/theme-sections';
import blockScroll from '../features/block-scroll';

const sections = {};

const selectors = {
  logo: '[data-slider-logo]',
  text: '[data-slider-text]',
  slide: '[data-slide]',
  slideData: 'data-slide',
  asNavFor: '#nav-for-',
  slideIndex: 'data-slide-index',
  flickityEnabled: 'flickity-enabled',
};

const classes = {
  classIsSelected: 'is-selected',
};

class LogoList {
  constructor(section) {
    this.container = section.container;
    this.slideshowText = this.container.querySelector(selectors.text);
    this.slideshowNav = this.container.querySelector(selectors.logo);
    this.logoSlides = this.slideshowNav.querySelectorAll(selectors.slide);
    this.textSlides = this.slideshowText.querySelectorAll(selectors.slide);
    this.resizeEvent = debounce(() => this.setSlideshowNavState(), 200);
    this.flkty = null;
    this.flktyNav = null;

    this.init();
  }

  init() {
    this.flkty = new Flickity(this.slideshowText, {
      autoPlay: false,
      prevNextButtons: false,
      contain: true,
      pageDots: false,
      wrapAround: false,
      selectedAttraction: 0.3,
      friction: 0.8,
      draggable: false,
    });

    this.logoSlides.forEach((element) => {
      element.addEventListener('click', (e) => {
        const index = parseInt(e.currentTarget.getAttribute(selectors.slideIndex));
        const hasSlider = this.slideshowNav.classList.contains(selectors.flickityEnabled);

        this.flkty.select(index);
        if (hasSlider) {
          this.flktyNav.select(index);
          if (!this.slideshowNav.classList.contains(classes.classIsSelected)) {
            this.flktyNav.playPlayer();
          }
        } else {
          const selectedSlide = this.slideshowNav.querySelector(`.${classes.classIsSelected}`);
          if (selectedSlide) {
            selectedSlide.classList.remove(classes.classIsSelected);
          }
          e.currentTarget.classList.add(classes.classIsSelected);
        }
      });
    });

    let maxHeight = -1;
    if (this.textSlides) {
      this.textSlides.forEach((element) => {
        const elementHeight = parseFloat(getComputedStyle(element, null).height.replace('px', ''));

        if (elementHeight > maxHeight) {
          maxHeight = elementHeight;
        }
      });

      this.textSlides.forEach((element) => {
        const elementHeight = parseFloat(getComputedStyle(element, null).height.replace('px', ''));

        if (elementHeight < maxHeight) {
          const calculateMargin = Math.ceil((maxHeight - elementHeight) / 2);
          element.style.margin = `${calculateMargin}px 0`;
        }
      });
    }

    this.initSlideshowNav();
  }

  onUnload() {
    const sliderInitialized = this.slideshowNav.classList.contains(selectors.flickityEnabled);
    if (sliderInitialized) {
      this.flktyNav.destroy();
    }

    this.flkty.destroy();

    window.removeEventListener('resize', this.resizeEvent);
  }

  onBlockSelect(evt) {
    const slide = this.slideshowNav.querySelector(`[${selectors.slideData}="${evt.detail.blockId}"]`);
    const slideIndex = parseInt(slide.getAttribute(selectors.slideIndex));

    if (this.slideshowNav.classList.contains(selectors.flickityEnabled)) {
      this.flktyNav.select(slideIndex);
      this.flktyNav.stopPlayer();
      this.slideshowNav.classList.add(classes.classIsSelected);
    } else {
      slide.dispatchEvent(new Event('click'));
    }

    this.flkty.select(slideIndex);
  }

  onBlockDeselect() {
    if (this.slideshowNav.classList.contains(selectors.flickityEnabled)) {
      this.flktyNav.playPlayer();
      this.slideshowNav.classList.remove(classes.classIsSelected);
    }
  }

  setSlideshowNavState() {
    const slidesCount = this.slideshowNav.querySelectorAll(selectors.slide).length;
    const slideWidth = 200;
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const slidesWidth = slidesCount * slideWidth;
    const sliderInitialized = this.slideshowNav.classList.contains(selectors.flickityEnabled);

    if (slidesWidth > windowWidth) {
      if (!sliderInitialized) {
        const selectedSlide = this.slideshowNav.querySelector(`.${classes.classIsSelected}`);
        if (selectedSlide) {
          selectedSlide.classList.remove(classes.classIsSelected);
        }

        this.flktyNav = new Flickity(this.slideshowNav, {
          autoPlay: 4000,
          prevNextButtons: false,
          contain: true,
          pageDots: false,
          wrapAround: true,
          watchCSS: true,
          selectedAttraction: 0.05,
          friction: 0.8,
        });

        if (this.flkty) {
          this.flkty.select(0);

          this.flktyNav.on('change', (index) => this.flkty.select(index));
        }
      }
    } else if (sliderInitialized) {
      this.flktyNav.destroy();
      this.logoSlides[0].classList.add(classes.classIsSelected);

      if (this.flkty) {
        this.flkty.select(0);
      }
    }
  }

  initSlideshowNav() {
    this.setSlideshowNavState();

    window.addEventListener('resize', this.resizeEvent);
  }
}

const LogoListSection = {
  onLoad() {
    sections[this.id] = new LogoList(this);
  },
  onUnload(e) {
    sections[this.id].onUnload(e);
  },
  onBlockSelect(e) {
    sections[this.id].onBlockSelect(e);
  },
  onBlockDeselect(e) {
    sections[this.id].onBlockDeselect(e);
  },
};

register('logos', [LogoListSection, blockScroll]);
